import { useEffect } from 'react';

export const useLinkSlash = (isReady: boolean) => {
  useEffect(() => {
    if (!isReady) {
      return;
    }

    const url = new URL(window.location.href);
    url.pathname = url.pathname.replace(/\/?$/, '/');
    window.history.replaceState(window.history.state, '', url);
  }, [isReady]);
};
